import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const ProtectedRoute = ({ isLoggedIn, children }) => {
    const navigate = useNavigate();
    useEffect(() => {
        if(!isLoggedIn)
            navigate("/login");
    }, [navigate]);
    if(isLoggedIn)
        return children;
};

export default ProtectedRoute;
